import React from 'react'
import { Container } from "react-bootstrap"
export default function Footer() {
  return (
    <footer className="py-4 mt-5 bg-dark text-white">
      <Container>
        <p className="text-center m-0 text-capitalize">All Copyright Reserved by <b>E-commerce</b> </p>
      </Container>
    </footer>
  )
}
